import React             from 'react';
import { withRouter }    from 'react-router';
import { connect }       from 'react-redux';
import { ClipLoader }    from 'react-spinners';
import { jokeFetchData } from '../../../actions/joke/joke';

class Joke extends React.Component {   
  constructor(props) {
    super(props);
    this.joke = this.joke.bind(this);
  }

  joke() {
    if (this.props.location.pathname.match(/\//gi).length === 1) {
      this.props.fetchData(false);
    }
    else {
      this.props.fetchData(true);
    }
  }

  componentDidMount() {
    this.joke();
  }

  render() {
    if (this.props.jokeIsLoading && !this.props.jokeHasErrored) {
      return (
        <ClipLoader
          color={'#072659'} 
          loading={this.props.jokeIsLoading} 
        />
      );
    }
    else if (!this.props.jokeIsLoading && !this.props.jokeHasErrored) {
      if (this.props.joke.joke) {
        return (
          <div style={{marginBottom: '10px'}}>
            <div style={{ marginBottom: '10px' }}>
              {this.props.joke.joke} 
            </div>
            <button className="c-btn c-btn--sm" onClick={this.joke}>
              <span className="c-btn__text">Feeling Lucky</span>
            </button>
          </div>
        );
      }
      else {
        return (
          <span></span>
        );
      }
    }
    else {
      return (
        <div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{color: 'red'}}><b>An Error has occurred</b></span>
          </div>
          <button className="c-btn c-btn--sm" onClick={this.joke}>
            <span className="c-btn__text">Feeling Lucky</span>
          </button>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    joke: state.joke.joke.joke,
    jokeHasErrored: state.joke.joke.jokeHasErrored,
    jokeIsLoading: state.joke.joke.jokeIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (reset) => dispatch(jokeFetchData(reset))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Joke));
